"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportUpdateUnlinkFund = exports.reportUpdateSuccess = exports.reportUpdateResetData = exports.reportUpdateLinkFund = exports.reportUpdateGetLinkFund = exports.reportUpdateFindFund = exports.reportUpdateError = exports.reportUpdateDelete = exports.reportUpdateCheckExist = exports.reportUpdateCheck = exports.reportUpdateAdd = void 0;
var _reportUpdate = require("./reportUpdate.constant");
// @flow

// common success
var reportUpdateSuccess = function reportUpdateSuccess(actionType, data) {
  return {
    type: _reportUpdate.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.reportUpdateSuccess = reportUpdateSuccess;
var reportUpdateError = function reportUpdateError(actionType, error) {
  return {
    type: _reportUpdate.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * save edit
 * @param payload
 * @returns api response
 * @description this function used to save edit.
 */
exports.reportUpdateError = reportUpdateError;
var reportUpdateAdd = function reportUpdateAdd(payload) {
  return {
    type: _reportUpdate.actionTypes.ADD,
    payload: payload
  };
};

/**
 * get page
 * @param payload
 * @returns api response
 * @description this function used to get page.
 */
exports.reportUpdateAdd = reportUpdateAdd;
var reportUpdateDelete = function reportUpdateDelete(payload) {
  return {
    type: _reportUpdate.actionTypes.DELETE,
    payload: payload
  };
};

/**
 * change brand
 * @param payload
 * @returns api response
 * @description this function used to change brand.
 */
exports.reportUpdateDelete = reportUpdateDelete;
var reportUpdateCheck = function reportUpdateCheck(payload) {
  return {
    type: _reportUpdate.actionTypes.CHECK,
    payload: payload
  };
};

/**
 * save edit
 * @param payload
 * @returns api response
 * @description this function used to save edit.
 */
exports.reportUpdateCheck = reportUpdateCheck;
var reportUpdateCheckExist = function reportUpdateCheckExist(payload) {
  return {
    type: _reportUpdate.actionTypes.CHECK_EXIST,
    payload: payload
  };
};

/**
 * get page
 * @param payload
 * @returns api response
 * @description this function used to get page.
 */
exports.reportUpdateCheckExist = reportUpdateCheckExist;
var reportUpdateLinkFund = function reportUpdateLinkFund(payload) {
  return {
    type: _reportUpdate.actionTypes.LINK_FUND,
    payload: payload
  };
};

/**
 * get page
 * @param payload
 * @returns api response
 * @description this function used to get page.
 */
exports.reportUpdateLinkFund = reportUpdateLinkFund;
var reportUpdateGetLinkFund = function reportUpdateGetLinkFund(payload) {
  return {
    type: _reportUpdate.actionTypes.GET_LINK_FUND,
    payload: payload
  };
};

/**
 * change brand
 * @param payload
 * @returns api response
 * @description this function used to change brand.
 */
exports.reportUpdateGetLinkFund = reportUpdateGetLinkFund;
var reportUpdateFindFund = function reportUpdateFindFund(payload) {
  return {
    type: _reportUpdate.actionTypes.FIND_FUND,
    payload: payload
  };
};

/**
 * change brand
 * @param payload
 * @returns api response
 * @description this function used to change brand.
 */
exports.reportUpdateFindFund = reportUpdateFindFund;
var reportUpdateUnlinkFund = function reportUpdateUnlinkFund(payload) {
  return {
    type: _reportUpdate.actionTypes.UNLINK_FUND,
    payload: payload
  };
};

/**
 * reser
 * @param payload
 * @returns api response
 * @description this function used to reset.
 */
exports.reportUpdateUnlinkFund = reportUpdateUnlinkFund;
var reportUpdateResetData = function reportUpdateResetData(payload) {
  return {
    type: _reportUpdate.actionTypes.RESET,
    payload: payload
  };
};
exports.reportUpdateResetData = reportUpdateResetData;